



















import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import axios from "axios";
import {namespace} from "vuex-class";
import {cloneDeep} from "lodash";
import {SERVER_HOST_QR} from "@/config";

const statistic_v4 = namespace('statistic_v4')

@Component({
  name: 'SurveyDashboardDemo',
  components: {}
})

export default class SurveyDashboardDemo extends Vue {
}
